// Reveals [data-feature-reveal]'s image gradually as it scrolls into view:
// sets --reveal (0 → 1) to how much of the element is on screen, and the
// CSS (scale/opacity/clip-path) reads that variable directly — no single
// on/off trigger, the image really grows as the user scrolls.
(function () {
  if (!('IntersectionObserver' in window)) return;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var thresholds = [];
  for (var i = 0; i <= 20; i++) thresholds.push(i / 20);

  document.querySelectorAll('[data-feature-reveal]').forEach(function (el) {
    el.style.setProperty('--reveal', '0');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          el.style.setProperty('--reveal', entry.intersectionRatio.toFixed(2));
        });
      },
      { threshold: thresholds }
    );

    observer.observe(el);
  });
})();
